import { AbstractPageDataProvider, PageDefaults } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { ICall } from "@/models/call.entity";
import callService from "@/services/mrfiktiv/services/call.service";
import { MrfiktivRealtimeSessionControllerFindAllParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const CallPageDataProvider = new (class extends AbstractPageDataProvider<
  ICall,
  MrfiktivRealtimeSessionControllerFindAllParamsGen
> {
  itemsPerPage = PageDefaults.DEFAULT_PAGE_SIZES[3];

  async getPage(query: MrfiktivRealtimeSessionControllerFindAllParamsGen): Promise<IPageViewModel<ICall>> {
    const res = await callService.getAll(query);

    const meta = res.meta;
    const data = (res.data ?? []) as ICall[];

    return { meta, data };
  }
})();
